import {
  useGetProfileQuery,
  IsCustomUrlAvailableDocument,
  IsCustomUrlAvailableQuery,
} from 'generated/graphql';
import { apolloClient } from '@client/api/graphql/client';
import { useAsyncQuery } from '@client/new/helpers/gql';
import { Async, toAsyncFetched } from '@client/new/helpers/types';
import { toProfileDomain } from './Profile.mapper';
import { ProfileModel } from './Profile.types';

export const checkCustomUrlAvailability = async (
  url: string,
): Promise<boolean> => {
  const result = await apolloClient.query<IsCustomUrlAvailableQuery>({
    query: IsCustomUrlAvailableDocument,
    variables: { customUrl: url },
  });

  return result.data.isCustomUrlAvailable;
};

export const useProfileModel = (creatorId: number): Async<ProfileModel> => {
  const shouldFetch = Number.isInteger(creatorId) && creatorId > 0;
  const res = useGetProfileQuery({
    fetchPolicy: 'cache-and-network',
    variables: { id: creatorId },
    skip: !shouldFetch,
  });

  const { data, refetch } = useAsyncQuery(res, 'creator', toProfileDomain);

  if (data.type !== 'fetched') return data;

  return toAsyncFetched({
    profile: data.value,
    refetch,
  });
};
